import React from "react";

import Spinner from "../../assets/images/oval.svg";
import "./loading.css";

const Loading = () => (
  <div className="loading-page">
    <div className="spinner-wrapper">
      <img src={Spinner} width="40" alt="Loading" />
    </div>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/system/components/Loading/index.jsx